import { render, staticRenderFns } from "./ReviewsTable.vue?vue&type=template&id=d111c868&"
import script from "./ReviewsTable.vue?vue&type=script&lang=js&"
export * from "./ReviewsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports